import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './red-team-exercises.css'

const RedTeamExercises = (props) => {
  return (
    <div className="red-team-exercises-container1">
      <Helmet>
        <title>Cysigil Network Pvt Ltd</title>
        <meta
          property="og:title"
          content="Red-Team-Exercises - Well Off Notable Fish"
        />
        <link
          rel="canonical"
          href="https://well-off-notable-fish-gmgkwg.teleporthq.app/red-team-exercises"
        />
      </Helmet>
      <Navigation></Navigation>
      <div className="red-team-exercises-container2">
        <div className="red-team-exercises-container3">
          <Script
            html={`<style>
@media (prefers-reduced-motion: reduce) {
* {
  animation-duration: 0s !important;
  transition-duration: 0s !important;
}
}
</style>`}
          ></Script>
        </div>
      </div>
      <section className="hero-redteam">
        <div className="hero-redteam-media">
          <img
            alt="Red team cybersecurity operations"
            src="https://images.pexels.com/photos/5473960/pexels-photo-5473960.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
            className="hero-redteam-background"
          />
        </div>
        <div className="hero-redteam-overlay"></div>
        <div className="hero-redteam-content">
          <div className="hero-redteam-wrapper">
            <div className="hero-redteam-badge">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle r="10" cx="12" cy="12"></circle>
                  <circle r="6" cx="12" cy="12"></circle>
                  <circle r="2" cx="12" cy="12"></circle>
                </g>
              </svg>
              <span>Adversary Simulation</span>
            </div>
            <h1 className="hero-title">Red Team Exercises</h1>
            <p className="hero-subtitle">
              Advanced adversary simulation testing that challenges your
              security posture through real-world attack scenarios. Our red team
              operations uncover vulnerabilities before threat actors do, with
              comprehensive purple team collaboration and actionable remediation
              roadmaps.
            </p>
            <div className="hero-redteam-buttons">
              <a href="#contact">
                <div className="btn-primary btn btn-lg">
                  <span>Request Assessment</span>
                </div>
              </a>
              <a href="#about">
                <div className="btn btn-lg btn-outline">
                  <span style={{ color: 'black' }}>Learn More</span>
                </div>
              </a>
            </div>
            <div className="hero-redteam-stats">
              <div className="hero-redteam-stat">
                <span className="hero-redteam-stat-number">50+</span>
                <span className="hero-redteam-stat-label">
                  Red Team Engagements
                </span>
              </div>
              <div className="hero-redteam-stat">
                <span className="hero-redteam-stat-number">98%</span>
                <span className="hero-redteam-stat-label">
                  Detection Improvement
                </span>
              </div>
              <div className="hero-redteam-stat">
                <span className="hero-redteam-stat-number">24/7</span>
                <span className="hero-redteam-stat-label">
                  Purple Team Support
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="features-redteam">
        <div className="features-redteam-container">
          <div className="features-redteam-header">
            <h2 className="section-title">Red Team Exercise Overview</h2>
            <p className="section-subtitle">
              Comprehensive adversary simulation designed to test your
              organization&apos;s security resilience, detection capabilities,
              and incident response effectiveness through controlled, real-world
              attack scenarios.
            </p>
          </div>
          <div className="features-redteam-grid">
            <div className="features-redteam-card">
              <div className="features-redteam-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <circle r="6" cx="12" cy="12"></circle>
                    <circle r="2" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="features-redteam-title">Exercise Goals</h3>
              <p className="features-redteam-description">
                Evaluate your security operations center&apos;s ability to
                detect, respond to, and mitigate sophisticated attacks. Test
                incident response procedures, identify gaps in detection
                coverage, and validate security controls effectiveness against
                advanced persistent threat techniques and tactics.
              </p>
              <ul className="features-redteam-list">
                <li className="features-redteam-list-item">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Detection capability assessment</span>
                </li>
                <li className="features-redteam-list-item">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Response procedure validation</span>
                </li>
                <li className="features-redteam-list-item">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Security posture improvement</span>
                </li>
              </ul>
            </div>
            <div className="features-redteam-card">
              <div className="features-redteam-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="8" cx="11" cy="11"></circle>
                    <path d="m21 21l-4.3-4.3"></path>
                  </g>
                </svg>
              </div>
              <h3 className="features-redteam-title">
                Scope &amp; Methodology
              </h3>
              <p className="features-redteam-description">
                Multi-phase engagement covering external reconnaissance,
                internal network penetration, privilege escalation, lateral
                movement, and data exfiltration scenarios. We employ
                industry-standard frameworks including MITRE ATT&amp;CK,
                simulating real adversary behaviors to challenge your defenses
                comprehensively.
              </p>
              <ul className="features-redteam-list">
                <li className="features-redteam-list-item">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>MITRE ATT&amp;CK framework alignment</span>
                </li>
                <li className="features-redteam-list-item">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Multi-vector attack simulation</span>
                </li>
                <li className="features-redteam-list-item">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Controlled environment testing</span>
                </li>
              </ul>
            </div>
            <div className="features-redteam-card">
              <div className="features-redteam-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                    <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
                  </g>
                </svg>
              </div>
              <h3 className="features-redteam-title">Expected Outcomes</h3>
              <p className="features-redteam-description">
                Detailed findings report documenting all successful attack
                vectors, security control bypasses, and detection gaps.
                Comprehensive remediation roadmap prioritized by risk severity,
                with clear timelines and ownership assignments. Enhanced blue
                team capabilities and improved organizational security
                awareness.
              </p>
              <ul className="features-redteam-list">
                <li className="features-redteam-list-item">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Executive and technical reports</span>
                </li>
                <li className="features-redteam-list-item">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Prioritized remediation guidance</span>
                </li>
                <li className="features-redteam-list-item">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Improved detection capabilities</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section className="process-redteam">
        <div className="process-redteam-container">
          <div className="process-redteam-header">
            <h2 className="section-title">Purple Team Collaboration Process</h2>
            <p className="section-subtitle">
              Integrated red and blue team collaboration that maximizes
              learning, accelerates detection improvement, and builds lasting
              defensive capabilities through structured knowledge transfer and
              real-time feedback loops.
            </p>
          </div>
          <div className="process-redteam-timeline">
            <div className="process-redteam-step">
              <div className="process-redteam-step-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M16 3.128a4 4 0 0 1 0 7.744M22 21v-2a4 4 0 0 0-3-3.87"></path>
                    <circle r="4" cx="9" cy="7"></circle>
                  </g>
                </svg>
              </div>
              <div className="process-redteam-step-content">
                <h3 className="process-redteam-step-title">
                  Pre-Exercise Planning
                </h3>
                <p className="process-redteam-step-description">
                  Joint kickoff meeting to establish objectives, define rules of
                  engagement, set communication protocols, and align on success
                  criteria. Both red and blue teams collaborate on scope
                  definition and establish clear escalation paths for critical
                  findings.
                </p>
              </div>
              <div className="process-redteam-step-number">
                <span>01</span>
              </div>
            </div>
            <div className="process-redteam-connector">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  d="M5 12h14m-7-7l7 7l-7 7"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </div>
            <div className="process-redteam-step">
              <div className="process-redteam-step-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="8" cx="11" cy="11"></circle>
                    <path d="m21 21l-4.3-4.3"></path>
                  </g>
                </svg>
              </div>
              <div className="process-redteam-step-content">
                <h3 className="process-redteam-step-title">
                  Active Exercise Phase
                </h3>
                <p className="process-redteam-step-description">
                  Red team executes simulated attacks while maintaining secure
                  communication channels with blue team. Scheduled debrief
                  sessions every 48 hours to share techniques, validate
                  detections, and adjust tactics. Real-time collaboration on
                  critical findings ensures immediate learning opportunities.
                </p>
              </div>
              <div className="process-redteam-step-number">
                <span>02</span>
              </div>
            </div>
            <div className="process-redteam-connector">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  d="M5 12h14m-7-7l7 7l-7 7"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </div>
            <div className="process-redteam-step">
              <div className="process-redteam-step-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 6v6l4 2"></path>
                    <circle r="10" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <div className="process-redteam-step-content">
                <h3 className="process-redteam-step-title">
                  Daily Sync Cadence
                </h3>
                <p className="process-redteam-step-description">
                  Structured daily standups via secure channels to discuss
                  progress, share indicators of compromise, and coordinate
                  detection rule development. Blue team receives non-specific
                  alerts about attack categories, enabling proactive hunting
                  without compromising exercise realism.
                </p>
              </div>
              <div className="process-redteam-step-number">
                <span>03</span>
              </div>
            </div>
            <div className="process-redteam-connector">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  d="M5 12h14m-7-7l7 7l-7 7"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </div>
            <div className="process-redteam-step">
              <div className="process-redteam-step-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="m15.477 12.89l1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                    <circle r="6" cx="12" cy="8"></circle>
                  </g>
                </svg>
              </div>
              <div className="process-redteam-step-content">
                <h3 className="process-redteam-step-title">
                  Post-Exercise Knowledge Transfer
                </h3>
                <p className="process-redteam-step-description">
                  Comprehensive debrief workshop where red team reveals complete
                  attack chain, demonstrates techniques, and walks through every
                  compromise. Blue team shares detection successes and gaps.
                  Joint development of detection rules, incident response
                  playbooks, and long-term defense strategies.
                </p>
              </div>
              <div className="process-redteam-step-number">
                <span>04</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="timeline-redteam">
        <div className="timeline-redteam-wrapper">
          <div className="timeline-redteam-header">
            <h2 className="section-title">Remediation Roadmap</h2>
            <p className="section-subtitle">
              Structured remediation plan with clear ownership, prioritized by
              business impact and exploitability. Each milestone includes
              specific deliverables, validation criteria, and success metrics to
              ensure measurable security improvement.
            </p>
          </div>
          <div className="timeline-redteam-scroll">
            <div className="timeline-redteam-track">
              <div className="timeline-redteam-item">
                <div className="timeline-redteam-marker">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M4 22V4a1 1 0 0 1 .4-.8A6 6 0 0 1 8 2c3 0 5 2 7.333 2q2 0 3.067-.8A1 1 0 0 1 20 4v10a1 1 0 0 1-.4.8A6 6 0 0 1 16 16c-3 0-5-2-8-2a6 6 0 0 0-4 1.528"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <div className="timeline-redteam-content">
                  <div className="timeline-redteam-phase">
                    <span>Week 1-2</span>
                  </div>
                  <h3 className="timeline-redteam-title">
                    Critical Remediation
                  </h3>
                  <p className="timeline-redteam-description">
                    Address all critical and high-severity findings that allow
                    immediate system compromise, privilege escalation, or data
                    exfiltration. Focus on patching exploited vulnerabilities,
                    implementing multi-factor authentication, and closing direct
                    attack paths.
                  </p>
                  <div className="timeline-redteam-owner">
                    <span>Owner: Security Operations Team</span>
                  </div>
                </div>
              </div>
              <div className="timeline-redteam-item">
                <div className="timeline-redteam-marker">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                      <path d="m9 12l2 2l4-4"></path>
                    </g>
                  </svg>
                </div>
                <div className="timeline-redteam-content">
                  <div className="timeline-redteam-phase">
                    <span>Week 3-4</span>
                  </div>
                  <h3 className="timeline-redteam-title">
                    Detection Enhancement
                  </h3>
                  <p className="timeline-redteam-description">
                    Deploy new detection rules, enhance SIEM correlation logic,
                    and implement behavioral analytics for attack techniques
                    that were missed. Tune existing alerts to reduce false
                    positives while maintaining detection coverage for red team
                    tactics.
                  </p>
                  <div className="timeline-redteam-owner">
                    <span>Owner: SOC &amp; Detection Engineering</span>
                  </div>
                </div>
              </div>
              <div className="timeline-redteam-item">
                <div className="timeline-redteam-marker">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                      <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
                    </g>
                  </svg>
                </div>
                <div className="timeline-redteam-content">
                  <div className="timeline-redteam-phase">
                    <span>Week 5-6</span>
                  </div>
                  <h3 className="timeline-redteam-title">
                    Process &amp; Procedure Updates
                  </h3>
                  <p className="timeline-redteam-description">
                    Revise incident response playbooks based on exercise
                    learnings, update escalation procedures, and document new
                    attack scenarios. Conduct tabletop exercises with updated
                    procedures to validate effectiveness and team readiness.
                  </p>
                  <div className="timeline-redteam-owner">
                    <span>Owner: Security Leadership</span>
                  </div>
                </div>
              </div>
              <div className="timeline-redteam-item">
                <div className="timeline-redteam-marker">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M16 3.128a4 4 0 0 1 0 7.744M22 21v-2a4 4 0 0 0-3-3.87"></path>
                      <circle r="4" cx="9" cy="7"></circle>
                    </g>
                  </svg>
                </div>
                <div className="timeline-redteam-content">
                  <div className="timeline-redteam-phase">
                    <span>Week 7-8</span>
                  </div>
                  <h3 className="timeline-redteam-title">
                    Team Training &amp; Awareness
                  </h3>
                  <p className="timeline-redteam-description">
                    Deliver targeted security awareness training addressing
                    social engineering techniques used during exercise. Train
                    SOC analysts on new attack patterns, enhance threat hunting
                    capabilities, and build organizational resilience through
                    education.
                  </p>
                  <div className="timeline-redteam-owner">
                    <span>Owner: Training &amp; Development</span>
                  </div>
                </div>
              </div>
              <div className="timeline-redteam-item">
                <div className="timeline-redteam-marker">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle r="10" cx="12" cy="12"></circle>
                      <circle r="6" cx="12" cy="12"></circle>
                      <circle r="2" cx="12" cy="12"></circle>
                    </g>
                  </svg>
                </div>
                <div className="timeline-redteam-content">
                  <div className="timeline-redteam-phase">
                    <span>Week 9-12</span>
                  </div>
                  <h3 className="timeline-redteam-title">
                    Architecture Hardening
                  </h3>
                  <p className="timeline-redteam-description">
                    Implement architectural improvements identified during
                    exercise including network segmentation, zero-trust
                    controls, and defense-in-depth strategies. Address systemic
                    weaknesses that enabled lateral movement and privilege
                    escalation.
                  </p>
                  <div className="timeline-redteam-owner">
                    <span>Owner: Infrastructure &amp; Architecture</span>
                  </div>
                </div>
              </div>
              <div className="timeline-redteam-item">
                <div className="timeline-redteam-marker">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <div className="timeline-redteam-content">
                  <div className="timeline-redteam-phase">
                    <span>Week 12+</span>
                  </div>
                  <h3 className="timeline-redteam-title">
                    Validation &amp; Continuous Improvement
                  </h3>
                  <p className="timeline-redteam-description">
                    Conduct validation testing to verify remediation
                    effectiveness. Establish continuous improvement program with
                    quarterly purple team exercises, regular threat hunting
                    activities, and ongoing security control maturity
                    assessments.
                  </p>
                  <div className="timeline-redteam-owner">
                    <span>Owner: Full Security Team</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="cta-redteam">
        <div className="cta-redteam-container">
          <div className="cta-redteam-split">
            <div className="red-team-exercises-thq-cta-redteam-block-elm cta-redteam-secondary cta-redteam-block">
              <div className="cta-redteam-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="cta-redteam-title">Request Assessment</h3>
              <p className="cta-redteam-description">
                Get a comprehensive red team exercise proposal tailored to your
                environment, compliance requirements, and security maturity
                level. Our team will provide detailed scope, methodology,
                timeline, and expected deliverables for your review.
              </p>
              <a href="#contact">
                <div className="btn-xl btn-accent btn">
                  <span>Get Proposal</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section className="about-redteam">
        <div className="about-redteam-container">
          <div className="about-redteam-header">
            <h2 className="section-title">Why Choose Cysigil</h2>
            <p className="section-subtitle">
              Industry-leading red team expertise backed by decades of offensive
              security experience, advanced certifications, and proven track
              record of helping organizations strengthen their security posture
              through realistic adversary simulation.
            </p>
          </div>
          <div className="about-redteam-grid">
            <div className="about-redteam-card">
              <div className="about-redteam-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="m15.477 12.89l1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                    <circle r="6" cx="12" cy="8"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="about-redteam-title">Elite Certifications</h3>
              <p className="about-redteam-description">
                Our red team operators hold OSCP, OSCE, GXPN, GREM, and
                industry-leading offensive security certifications. Continuous
                training in emerging attack techniques ensures your testing
                reflects current threat actor capabilities.
              </p>
            </div>
            <div className="about-redteam-card">
              <div className="about-redteam-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <circle r="6" cx="12" cy="12"></circle>
                    <circle r="2" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="about-redteam-title">Real-World Experience</h3>
              <p className="about-redteam-description">
                Over 500 red team engagements across financial services,
                healthcare, technology, and critical infrastructure sectors. Our
                team has worked with Fortune 500 companies and government
                agencies worldwide.
              </p>
            </div>
            <div className="about-redteam-card">
              <div className="about-redteam-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="about-redteam-title">Proven Methodology</h3>
              <p className="about-redteam-description">
                MITRE ATT&amp;CK-aligned testing framework ensures comprehensive
                coverage of adversary tactics, techniques, and procedures.
                Structured approach balances stealth with measurable objectives
                to maximize learning outcomes.
              </p>
            </div>
            <div className="about-redteam-card">
              <div className="about-redteam-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M16 3.128a4 4 0 0 1 0 7.744M22 21v-2a4 4 0 0 0-3-3.87"></path>
                    <circle r="4" cx="9" cy="7"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="about-redteam-title">Purple Team Excellence</h3>
              <p className="about-redteam-description">
                True collaborative security testing where knowledge transfer is
                prioritized. Our purple team approach accelerates detection
                capability development and builds lasting defensive improvements
                beyond single engagement.
              </p>
            </div>
            <div className="about-redteam-card">
              <div className="about-redteam-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                    <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
                  </g>
                </svg>
              </div>
              <h3 className="about-redteam-title">Actionable Reporting</h3>
              <p className="about-redteam-description">
                Executive and technical reports tailored to different audiences.
                Clear remediation guidance with prioritization, timelines, and
                ownership assignments. Every finding includes validation steps
                to measure improvement.
              </p>
            </div>
            <div className="about-redteam-card">
              <div className="about-redteam-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 6v6l4 2"></path>
                    <circle r="10" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="about-redteam-title">Ongoing Support</h3>
              <p className="about-redteam-description">
                Post-engagement support includes remediation validation,
                detection rule development assistance, and quarterly check-ins.
                We&apos;re invested in your long-term security success, not just
                single project delivery.
              </p>
            </div>
          </div>
        </div>
      </section>
      <div className="red-team-exercises-container4">
        <div className="red-team-exercises-container5">
          <Script
            html={`<style>
        @keyframes slideUp {from {opacity: 0;
transform: translateY(30px);}
to {opacity: 1;
transform: translateY(0);}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="red-team-exercises-container6">
        <div className="red-team-exercises-container7">
          <Script
            html={`<script defer data-name="timeline-scroll">
(function(){
  const timelineScroll = document.querySelector(".timeline-redteam-scroll")
  if (timelineScroll) {
    timelineScroll.addEventListener("wheel", (e) => {
      if (e.deltaY !== 0) {
        e.preventDefault()
        timelineScroll.scrollLeft += e.deltaY
      }
    })
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default RedTeamExercises
